import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

import { useToast } from '@/components/ui'
import { usersService } from '@/services/http/usersService'

type Props = {
  startDate?: Date
  endDate?: Date
}

export const useDashboardActiveUsersRate = ({ startDate, endDate }: Props) => {
  const { toast } = useToast()

  const { data, isError, isLoading, refetch } = useQuery({
    queryKey: [
      'dashboardActiveUsersRate',
      {
        startDate,
        endDate,
      },
    ],
    queryFn: () =>
      usersService.getDashboardActiveUsersRate({
        startDate,
        endDate,
      }),
  })

  useEffect(() => {
    if (isError)
      toast({
        title: 'Erro ao carregar dados da taxa de usuários ativos do dashboard',
        variant: 'destructive',
      })
  }, [isError, toast])

  if (data) {
    const { activeUsers, percentage, totalUsers } = data
    return {
      activeUsers,
      percentage,
      totalUsers,
      isLoading,
      refetchDashboardActiveUsersRate: refetch,
    }
  }

  return {
    activeUsers: 0,
    percentage: '0%',
    totalUsers: 0,
    isLoading,
    refetchDashboardActiveUsersRate: refetch,
  }
}
